import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_DRIVE,
    StoreType,
    LoadDriveVersionById,
    setDriveVersionEdit,
    setDriveVersionReloadEdit,
    isProjectFolderOpened,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface DriveVersionProps {
    versionId: number
}

const RevisionEdit = ({
    versionId,
}: DriveVersionProps) => {
    const drivePath = useSelector((state: StoreType) => state.drive.drivePath)
    const version = useSelector((state: StoreType) => state.drive.version.versionEdit)
    const file = useSelector((state: StoreType) => state.drive.file.fileEdit)
    const reloadEdit = useSelector((state: StoreType) => state.drive.version.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadDriveVersionById(versionId).then((res) => {
            dispatch(setDriveVersionEdit(res))
            setLoadState(IDLE)

            dispatch(setDriveVersionReloadEdit(false))
            setTimeout(() => {
                dispatch(setDriveVersionReloadEdit(true))
            }, 0)
        })
    }, [])

    const projectId = isProjectFolderOpened(drivePath)

    const accountEditAccess = hasAccess(PRM_DRIVE, EDIT)
    const projectEditAccess = hasProjectAccess(PRM_DRIVE, EDIT, projectId)
    const editAccess = !projectId
        ? accountEditAccess
        : projectEditAccess

    const allowedToEdit = (
        editAccess
        || file.owner === userData.userId
        || (version && version.owner === userData.userId)
    ) && (version && version.accountId === userData.accountId)

    if (!version) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {`${allowedToEdit ? lang.editRevision : lang.viewRevision} # ${version.id}`}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form version={version} editAccess={allowedToEdit} />
                }
                {
                    reloadEdit
                    && <Form version={version} editAccess={allowedToEdit} />
                }
            </PageContent>
        </Container>
    )
}
export default RevisionEdit
